import {domain} from '../conf/config';

window.onresize = function(){
  $(".modal").css({
    "margin-top": document.body.scrollTop + "px",
    "height": window.innerHeight + "px"
  });
};

// find/findIndex for IE
Array.prototype.find = Array.prototype.find || function (fn, context) {
  if (typeof fn === "function") {
    for (var k = 0, length = this.length; k < length; k++) {
      if (fn.call(context, this[k], k, this)) {
        return this[k];
      }
    }
  }
  return undefined;
};


Array.prototype.findIndex = Array.prototype.findIndex || function (fn, context) {
  if (typeof fn === "function") {
    for (var k = 0, length = this.length; k < length; k++) {
      if (fn.call(context, this[k], k, this)) {
        return k;
      }
    }
  }
  return -1;
};

export function b64EncodeUnicode(str) {
  // return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p1) {
  //   return String.fromCharCode('0x' + p1);
  // }));
  str = btoa(str);
  const l = str.length;
  const res = [];
  const num = str.indexOf('=');
  if (num !== -1) {
    str = str.substr(0, num);
  }
  str += num === -1 ? 0 : l - num;
  const len = str.length;
  const mid = Math.floor(len / 2);

  for (let i = 0; i < len; i++) {
    if (i < mid) {
      res.push(str[mid - 1 - i]);
    } else {
      res.push(str[len - 1 - i + mid]);
    }
  }

  return res.join('');
}

export function checkdomain(str) {
  return domain.indexOf(str) > -1;
}


// WEBPACK FOOTER //
// ./src/utils/utils.js